const actions = {
  GET_AllAGENTS_DATA: "GET_AllAGENTS_DATA",
  GET_AllAGENTS_DATA_SUCCESS: "GET_ALLAGENTS_DATA_SUCCESS",
  GET_ALLAGENTS_DATA_FAILED: "GET_ALLAGENTS_DATA_FAILED",
  ADD_AGENTS: "ADD_AGENS",
  ADD_AGENTS_SUCCESS: "ADD_AGENTS_SUCCESS",
  ADD_AGENTS_FAILED: "ADD_AGENTS_FAILED",
   UPDATE_AGENT_DETAIL: "UPDATE_AGENT_DETAIL",
  UPDATE_AGENT_DETAIL_SUCCESS: "UPDATE_AGENT_DETAIL_SUCCESS",
  UPDATE_AGENT_DETAIL_FAILED: "UPDATE_AGENT_DETAIL_FAILED",

  getAllAgentsData: () => ({
    type: actions.GET_AllAGENTS_DATA,
  }),
  getAllAgentsDataSuccess: (data) => ({
    type: actions.GET_AllAGENTS_DATA_SUCCESS,
    payload: { data },
  }),
  getAllAgentsDataFailed: (error) => ({
    type: actions.GET_ALLAGENTS_DATA_FAILED,
    payload: { error },
  }),

addAgents: (data) => ({
    type: actions.ADD_AGENTS,
    payload: { data },
  }),
  addAgentsSuccess: (message, data) => ({
    type: actions.ADD_AGENTS_SUCCESS,
    payload: { message, data },
  }),
  addAgentsFailed: (error) => ({
    type: actions.ADD_AGENTS_FAILED,
    payload: { error },
  }),
   updateAgentDetail: (id, payload) => ({
    type: actions.UPDATE_AGENT_DETAIL,
    payload: { id, payload }
  }),
  updateAgentDetailSuccess: (id, message, updatedData) => ({
    type: actions.UPDATE_AGENT_DETAIL_SUCCESS,
    payload: { id, message, updatedData }
  }),
  updateAgentDetailFailed: (error) => ({
    type: actions.UPDATE_DETAIL_AGENT_FAILED,
    payload: { error }
  }),
};

export default actions;